import { RestaurantResponseType } from '../restaurant/restaurant.types';

export enum TaxConfigurationType {
  PERCENTAGE = 'percentage',
  FIXED = 'fixed',
  SLAB = 'slab',
  DISABLED = 'disabled',
}

export enum RoundingConfig {
  HALF_EVEN = 'half_even',
  HALF_UP = 'half_up',
  ROUND_DOWN = 'round_down',
  ROUND_UP = 'round_up',
}

export interface ITaxConfigurationFormula {
  rate: number;
  takeOutRate: number;
}

export interface TaxRequestType {
  name: string;
  percentage: number;
  restaurantId?: number;
}

export interface TaxResponseType {
  name: string;
  percentage: number;
  restaurant: RestaurantResponseType;
  createdAt: Date;
  updatedAt: Date;
}
